export default __webpack_public_path__ + "static/step_11-02b0bd43c70cf4065f88c128c105a171.png";